// frontend/src/api/email_spam.ts
/**
 * Tenant per-mailbox spam filter API.
 *
 * Backed by /api/email/spam-rules and
 * /api/email/mailboxes/{id}/spam-rules.
 */
import { fetchAPI } from './client';

const API_BASE_URL = '/api';

export type SpamRuleKind = 'allow' | 'deny';

export interface SpamRule {
  id: number;
  mailbox_id: number;
  user_id: number;
  kind: SpamRuleKind;
  pattern: string;
  created_at: string | null;
}

export interface SpamRuleCreateBody {
  kind: SpamRuleKind;
  pattern: string;
}

export const emailSpamAPI = {
  listRules(): Promise<SpamRule[]> {
    return fetchAPI<SpamRule[]>(`${API_BASE_URL}/email/spam-rules`);
  },

  addRule(mailboxId: number, body: SpamRuleCreateBody): Promise<SpamRule> {
    return fetchAPI<SpamRule>(
      `${API_BASE_URL}/email/mailboxes/${mailboxId}/spam-rules`,
      { method: 'POST', body: JSON.stringify(body) },
    );
  },

  deleteRule(ruleId: number): Promise<void> {
    return fetchAPI<void>(`${API_BASE_URL}/email/spam-rules/${ruleId}`, {
      method: 'DELETE',
    });
  },
};
